/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */
import { getApiUrl } from "../api";
import { useEffect, useState } from "react";
import { Link } from "./AppLink";
import {
  clearAuthReturnPath,
  clearStoredAuth,
  getAccountDashboardPath,
  getStoredToken,
  getStoredUser,
} from "../auth";


export default function Header() {
  const isArabicPage = typeof window !== "undefined" && window.location.pathname.toLowerCase().startsWith("/ar");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openMobileDropdown, setOpenMobileDropdown] = useState("");
  const [openLanguageMenu, setOpenLanguageMenu] = useState("");
  const [authenticatedUser, setAuthenticatedUser] = useState(() =>
    getStoredToken() ? getStoredUser() : null
  );

  useEffect(() => {
    const refreshUser = () => {
      setAuthenticatedUser(getStoredToken() ? getStoredUser() : null);
    };
    window.addEventListener("auth:changed", refreshUser);
    window.addEventListener("storage", refreshUser);
    return () => {
      window.removeEventListener("auth:changed", refreshUser);
      window.removeEventListener("storage", refreshUser);
    };
  }, []);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setOpenMobileDropdown("");
  };

  const toggleMobileDropdown = (menuName) => (event) => {
    event.preventDefault();
    setOpenMobileDropdown((currentMenu) => currentMenu === menuName ? "" : menuName);
  };

  const languagePath = (arabic) => {
    const current = window.location.pathname || "/";
    const base = current.replace(/^\/ar(?=\/|$)/i, "") || "/";
    const localizedPath = arabic
      ? `/ar${base === "/" ? "" : base}`
      : base === "/" ? "/home" : base;
    return `${localizedPath}${window.location.search}${window.location.hash}`;
  };

  const changeLanguage = (arabic) => (event) => {
    event.preventDefault();
    const destination = languagePath(arabic);
    setOpenLanguageMenu("");
    if (`${window.location.pathname}${window.location.search}${window.location.hash}` === destination) return;
    window.history.pushState({}, "", destination);
    window.dispatchEvent(new Event("app:navigate"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderLanguageMenu = (menuId, iconSize) => (
    <div className={`header-language-menu ${openLanguageMenu === menuId ? "open" : ""}`}>
      <button
        type="button"
        className="header-language-trigger"
        aria-label="Choose language"
        aria-expanded={openLanguageMenu === menuId}
        onClick={() => setOpenLanguageMenu((current) => current === menuId ? "" : menuId)}
      >
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="#114c5c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
        </svg>
      </button>
      <div className="header-language-dropdown" role="menu" onClick={(event) => {
        const languageLink = event.target.closest("a[role='menuitem']");
        if (languageLink) changeLanguage(languageLink.lang === "ar")(event);
      }}>
        <a href={languagePath(false)} role="menuitem">English <span>| EN</span></a>
        <a href={languagePath(true)} role="menuitem" lang="ar" dir="rtl">العربية <span>| AR</span></a>
      </div>
    </div>
  );

  const handleLogout = () => {
    const token = getStoredToken();
    clearStoredAuth();
    clearAuthReturnPath();
    closeMobileMenu();

    window.history.replaceState({}, "", "/login");
    window.dispatchEvent(new Event("app:navigate"));
    window.scrollTo({ top: 0, behavior: "smooth" });

    fetch(getApiUrl("/api/Logout.ashx"), {
      method: "POST",
      credentials: "include",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      keepalive: true,
    }).catch(() => {
      // Local authentication was cleared and navigation already completed.
    });
  };

  const renderAccount = (iconSize, mobile = false) => {
    if (authenticatedUser) {
      const dashboardPath = getAccountDashboardPath(
        authenticatedUser.profile?.accounttype || authenticatedUser.accounttype
      );

      return (
        <div className="header-user-account">
          {!mobile && <a href={dashboardPath} className="header-welcome-name">
            Welcome, {authenticatedUser.userName || authenticatedUser.user || "User"}
          </a>}
          <button type="button" className="header-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      );
    }

    return (
      <Link
        to="/login"
        className="tooltip-trigger"
        data-tooltip="Login"
        onClick={clearAuthReturnPath}
      >
        <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="#114c5c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </Link>
    );
  };

  const accountName = authenticatedUser?.profile?.fullname
    || authenticatedUser?.userName
    || authenticatedUser?.user
    || "User";
  const accountDashboardPath = authenticatedUser
    ? getAccountDashboardPath(authenticatedUser.profile?.accounttype || authenticatedUser.accounttype)
    : "";
  const accountProfilePath = accountDashboardPath === "/beneficent-dashboard"
    ? `${accountDashboardPath}?tab=profile-tab`
    : accountDashboardPath;

  return (
    <>
    <header className="new-header-wrap header-new sticky-top">
      <div className="top-header">
        <div className="container">
          <div className="top-header-logos-w">
            <div className="logo-section">
              <Link to="/home"></Link>
              <Link to="/home">
                <img src="/images/img/Tarahum_logo-b.png" alt="Tarahum Foundation" className="img-fluid" />
              </Link>
            </div>
            <div className="search-container uae-logo-s">
              <img src="/images/img/uae-logo.png" alt="Tarahum Foundation" className="img-fluid" />
            </div>
            <div className="mob-menu-show">
              <div className="mob-mnu-incs-st ">
                <div className="header-icons">
                  <div className="header-icons">
                    {authenticatedUser ? (
                      <button
                        type="button"
                        className="tooltip-trigger mobile-profile-menu-trigger"
                        data-tooltip="Profile"
                        aria-label="Open profile menu"
                        aria-expanded={isMobileMenuOpen}
                        onClick={() => setIsMobileMenuOpen(true)}
                      >
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#114c5c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                      </button>
                    ) : renderAccount(22, true)}
                    {renderLanguageMenu("mobile", 22)}
                    <Link to="/cart" className="tooltip-trigger" data-tooltip="Cart">
                      <svg width="22" height="22" viewBox="0 -2.55 20.094 20.094" xmlns="http://www.w3.org/2000/svg" fill="#114c5c" stroke="#114c5c">
                        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path id="Path_15" data-name="Path 15" d="M518.8,829.36c-.678,1.556-1.213,2.66-2.709,2.66h-8.128a2.664,2.664,0,0,1-2.71-2.66l-.8-7.36h-3.484v-1h4.375l.361,3.014h15.358Zm-12.556,0a1.874,1.874,0,0,0,1.72,1.633H516.1c.9,0,1.271-.72,1.657-1.633l1.837-4.382H505.8Zm1.225,3.64a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,507.474,833Zm-.531,1.969h1V834h-1ZM515.474,833a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,515.474,833Zm-.531,1.969h1V834h-1Z" transform="translate(-500.973 -821)" fill="#444"></path>
                        </g>
                      </svg>
                    </Link>
                  </div>
                </div>
                <button
                  type="button"
                  className="nw-mobile-btn"
                  id="nwOpenMenu"
                  onClick={() => setIsMobileMenuOpen(true)}
                  aria-label="Open menu"
                  aria-expanded={isMobileMenuOpen}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <nav className="nav-bar" id="mainNav sticky-top">
        <div className="container ">
          <div className="nav-flex">
            <ul className="nav-links">
              <li>
                <Link to="/home" className="active">
                  {"Home"}
                </Link>
              </li>
              <li className="dropdown">
                <a href="#">
                  {"About Us "}
                  <span className="arrow">
                    {"▾"}
                  </span>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/about-us">
                      {"Foundation's Brief"}
                    </Link>
                  </li>
                  <li>
                    <Link to="/directors">
                      {"Board of Directors"}
                    </Link>
                  </li>
                  <li>
                    <Link to="/organization-structure">
                      {"Organization Structure"}
                    </Link>
                  </li>
                  <li>
                    <Link to="/foundation-policies">
                      {"Foundation's Policies"}
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="dropdown">
                <a href="#">
                  {"Donations "}
                  <span className="arrow">
                    {"▾"}
                  </span>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/quick-donation">
                      {"Quick Donation"}
                    </Link>
                  </li>
                  <li>
                    <Link to="/in-kind-donation">
                      {"In Kind Donation"}
                    </Link>
                  </li>
                  <li>
                    <Link to="/our-projects">
                      {"Our Projects"}
                    </Link>
                  </li>
                  <li>
                    <Link to="/critical-cases">
                      {"Critical Cases"}
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="dropdown">
                <a href="#">
                  {"Assistance "}
                  <span className="arrow">
                    {"▾"}
                  </span>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/submit-aid-request">
                      {"Submit Aid Request"}
                    </Link>
                  </li>
                  <li>
                    <Link to="/track-aid-request-status">
                      {"Track Status"}
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="dropdown">
                <a href="#">
                  {"Media Center"}
                  <span className="arrow">
                    {"▾"}
                  </span>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/news">
                      {"Foundation News"}
                    </Link>
                  </li>
                  <li>
                    <Link to="/magazines">
                      {"Tarahum Magazine"}
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="banks-accounts">
                  {"Bank Accounts"}
                </Link>
              </li>
              <li>
                <Link to="open-data">
                  {"Open Data"}
                </Link>
              </li>
              <li>
                <Link to="contact-us">
                  {"Contact Us"}
                </Link>
              </li>
            </ul>
            <div className="header-icons">
              <div className="header-icons">
                {renderAccount(24)}
                <Link to="/quick-donation" className="tooltip-trigger" data-tooltip="Donation">
                  <img src="/images/img/donation1.svg" width="24px" alt="" />
                </Link>
                {renderLanguageMenu("desktop", 24)}
                <Link to="/cart" className="tooltip-trigger" data-tooltip="Cart">
                  <svg width="24" height="24" viewBox="0 -2.55 20.094 20.094" xmlns="http://www.w3.org/2000/svg" fill="#114c5c" stroke="#114c5c">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path id="Path_15" data-name="Path 15" d="M518.8,829.36c-.678,1.556-1.213,2.66-2.709,2.66h-8.128a2.664,2.664,0,0,1-2.71-2.66l-.8-7.36h-3.484v-1h4.375l.361,3.014h15.358Zm-12.556,0a1.874,1.874,0,0,0,1.72,1.633H516.1c.9,0,1.271-.72,1.657-1.633l1.837-4.382H505.8Zm1.225,3.64a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,507.474,833Zm-.531,1.969h1V834h-1ZM515.474,833a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,515.474,833Zm-.531,1.969h1V834h-1Z" transform="translate(-500.973 -821)" fill="#444"></path>
                    </g>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div
        className={`nw-overlay ${isMobileMenuOpen ? "active" : ""}`}
        id="nwOverlay"
        onClick={closeMobileMenu}
      ></div>
      <div className={`nw-mobile-menu ${isMobileMenuOpen ? "active" : ""}`} id="nwMobileMenu">
        <div className="nw-mobile-top">
          <h3>
            {"Menu"}
          </h3>
          <div className="nw-close" id="nwCloseMenu" onClick={closeMobileMenu} role="button" tabIndex="0">
            {"×"}
          </div>
        </div>
        {authenticatedUser && (
          <section className="mobile-menu-account" aria-label="Signed-in account">
            <div className="mobile-menu-account-name">
              <span>Signed in as</span>
              <strong>{accountName}</strong>
            </div>
            <div className="mobile-menu-account-actions">
              <Link to={accountProfilePath} className="mobile-menu-profile-link" onClick={closeMobileMenu}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                View Profile
              </Link>
              <button type="button" className="mobile-menu-logout" onClick={handleLogout}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                  <polyline points="16 17 21 12 16 7"></polyline>
                  <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                Logout
              </button>
            </div>
          </section>
        )}
        <ul className="nw-mobile-links" id="nwMobileLinks">
          <li>
            <Link to="/home" className="active">
              {"Home"}
            </Link>
          </li>
          <li className={`nw-mobile-item ${openMobileDropdown === "about" ? "active" : ""}`}>
            <a href="#" aria-expanded={openMobileDropdown === "about"} onClick={toggleMobileDropdown("about")}>
              {"About Foundation "}
              <span className="nw-mobile-toggle-icon">
                {openMobileDropdown === "about" ? "-" : "+"}
              </span>
            </a>
            <div className="nw-mobile-dropdown">
              <Link to="/about-us">
                {"Foundation's Brief"}
              </Link>
              <Link to="/directors">
                {"Board of Directors"}
              </Link>
              <Link to="/organization-structure">
                {"Organization Structure"}
              </Link>
              <Link to="/foundation-policies">
                {"Foundation's Policies"}
              </Link>
            </div>
          </li>
          <li className={`nw-mobile-item ${openMobileDropdown === "donations" ? "active" : ""}`}>
            <a href="#" aria-expanded={openMobileDropdown === "donations"} onClick={toggleMobileDropdown("donations")}>
              {"Donations "}
              <span className="nw-mobile-toggle-icon">
                {openMobileDropdown === "donations" ? "-" : "+"}
              </span>
            </a>
            <div className="nw-mobile-dropdown">
              <Link to="/quick-donation">
                {"Quick Donation"}
              </Link>
              <Link to="in-kind-donation">
                {"In Kind Donation"}
              </Link>
              <Link to="/our-projects">
                {"Our Projects"}
              </Link>
              <Link to="/critical-cases">
                {"Critical Cases"}
              </Link>
            </div>
          </li>
          <li className={`nw-mobile-item ${openMobileDropdown === "aids" ? "active" : ""}`}>
            <a href="#" aria-expanded={openMobileDropdown === "aids"} onClick={toggleMobileDropdown("aids")}>
              {isArabicPage ? "المساعدات " : "Assistance "}
              <span className="nw-mobile-toggle-icon">
                {openMobileDropdown === "aids" ? "-" : "+"}
              </span>
            </a>
            <div className="nw-mobile-dropdown">
              <Link to="/submit-aid-request">
                {"Submit Aid Request"}
              </Link>
              <Link to="/track-aid-request-status">
                {"Track Status"}
              </Link>
            </div>
          </li>
          <li className={`nw-mobile-item ${openMobileDropdown === "media" ? "active" : ""}`}>
            <a href="#" aria-expanded={openMobileDropdown === "media"} onClick={toggleMobileDropdown("media")}>
              {"Media Center "}
              <span className="nw-mobile-toggle-icon">
                {openMobileDropdown === "media" ? "-" : "+"}
              </span>
            </a>
            <div className="nw-mobile-dropdown">
              <Link to="/news">
                {"Foundation News"}
              </Link>
              <Link to="/magazines">
                {"Tarahum Magazine"}
              </Link>
            </div>
          </li>
          <li>
            <Link to="banks-accounts">
              {"Banks Accounts"}
            </Link>
          </li>
          <li>
            <Link to="open-data">
              {"Open Data"}
            </Link>
          </li>
          <li>
            <Link to="contact-us">
              {"Contact us"}
            </Link>
          </li>
        </ul>
      </div>
    </header>
    </>
  );
}
